
import {BrowserRouter as Router,Routes,Route, Link} from 'react-router-dom'
import Header from'./Components/Header'
import Home from './Components/Home'
import Coins from './Components/Coins'
import Exchanges from './Components/Exchanges'
import Coindetail from './Components/Coindetail'
import Footer from './Components/Footer'

function App() {
  return (
    <Router>
      <Header/>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/coins' element={<Coins/>} />
        <Route path='/exchanges' element={<Exchanges/>} />
        <Route path="/coin/:id" element={<Coindetail/>} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
